// Imports
import firebase from '../config/FirebaseConfig'

// Setup
const db = firebase.firestore()

// Get the agency listing by the firebase id
const getListingById = async (id) => {
  const listing = await db.collection('agency-listings').doc(id).get()
  return {
    id: listing.id,
    ...listing.data()
  }
}

// Return the first agency listing for the team (return null if no listing found)
const getListingByTeamId = async (teamId) => {
  const listings = await db.collection('agency-listings').where('teamId', '==', teamId).get()
  if (listings.docs.length === 0) return null
  return {
    id: listings.docs[0].id,
    ...listings.docs[0].data()
  }
}

export default {
  getListingById,
  getListingByTeamId
}